/**
 *
 * ComparativeAnalysisTable
 *
 */

import React, { Fragment, Component } from "react"
import "./index.less"
import { Spin, Skeleton, Tooltip, Popover } from "antd"
import { Icon } from "@ant-design/compatible"
import PropTypes from "prop-types"
import FlechaSVG from "../../images/iconoFlecha.svg"
import { QuestionCircleFilled } from "@ant-design/icons"
import { loadTexts, sanitize } from "../../utils/i18n"
import InfiniteScroll from "react-infinite-scroller"

/* eslint-disable react/prefer-stateless-function */
class ComparativeAnalysisTable extends Component {
  intlComparativeAnalysisTable = loadTexts("reports_comparative_view")
    .comparativeAnalysisTable

  // state = {
  //   page: 1
  // }

  componentDidUpdate() {
    if (document.getElementById("isSkeleton")) {
      const myElement = document.getElementById("isSkeleton")
      const topPos = myElement.offsetTop
      document.getElementById("comparativeAnalysisTable").scrollTop =
        topPos - 246
    }
  }

  renderHeaderItem = (h, child) => {
    const { openDimensions, firstHeaderColumnText } = this.props
    const item = (
      <th
        className={`verticalText ${child ? "__isChild" : ""}`}
        style={
          h.childs.length > 0
            ? {
                cursor: "pointer",
                background: h.engagement ? (child ? "#F6FAFE" : "#F3F8FE") : "",
                textTransform: h.engagement ? (child ? "" : "uppercase") : "",
              }
            : {
                background: h.engagement ? (child ? "#F6FAFE" : "#F3F8FE") : "",
                textTransform: h.engagement ? (child ? "" : "uppercase") : "",
              }
        }
        onClick={() =>
          h.childs.length > 0 ? this.props.clickDimension(h.id_dimension) : null
        }>
        <div>
          <span>
            {h.dimension_name === null
              ? firstHeaderColumnText
              : h.dimension_name}
          </span>
          {h.childs.length > 0 ? (
            openDimensions.includes(h.id_dimension) ? (
              <img src={FlechaSVG} style={{ transform: "rotate(90deg)" }} />
            ) : (
              <img src={FlechaSVG} style={{ transform: "rotate(-90deg)" }} />
            )
          ) : null}
        </div>
      </th>
    )
    if (this.props.isEngagement) {
      return item
    }
    if (!h.engagement) {
      return item
    }
  }

  renderHeaderList = (headers, child = false) => {
    const { openDimensions } = this.props
    return headers.map((h, i) => (
      <Fragment key={i}>
        {this.renderHeaderItem(h, child)}
        {openDimensions.includes(h.id_dimension) &&
          this.renderHeaderList(h.childs, true)}
      </Fragment>
    ))
  }

  renderDivisionColumn = (columns, name) => {
    const { openDimensions, indicatorLoading, indicatorSelected } = this.props
    const content = (
      <Spin className="spinListFilter" size="large" spinning={indicatorLoading}>
        {!indicatorLoading ?
          (
            <div className="comparativeAnalysisComponent-preview">
              <div className="comparativeAnalysisComponent-preview-header">
                <b>{indicatorSelected.dimension_name} </b>
                <span style={{ backgroundColor: indicatorSelected.color }}>
                  {indicatorSelected.value_visible}
                </span>
              </div>
              <div style={{ overflow: "auto", maxHeight: 213 }}>
                {indicatorSelected.questions &&
                  Array.isArray(indicatorSelected.questions) &&
                  indicatorSelected.questions.map((q, i) => (
                    <div
                      key={i}
                      className="comparativeAnalysisComponent-preview-question">
                      <i className="comparativeAnalysisComponent-preview-question-dot" />
                      <p>{q.question_name}</p>
                      <span style={{ backgroundColor: q.color }}>
                        {q.value_visible}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
          )
        :(
          <div className="comparativeAnalysisComponent-preview-spaceLoading" />
        )
      }
      </Spin>
    )

    const contentNotDimension = (
      <div className="comparativeAnalysisComponent-preview">
        <div className="comparativeAnalysisComponent-preview-header">
        Este <strong>grupo</strong> no cuenta con esta <strong>dimensión</strong> en el cuestionario.
        </div>
      </div>
    )

    const contentNotSubDimension = (
      <div className="comparativeAnalysisComponent-preview">
        <div className="comparativeAnalysisComponent-preview-header">
        Este <strong>grupo</strong> no cuenta con esta <strong>subdimensión</strong> en el cuestionario.
        </div>
      </div>
    )

    const contentNotAnonymitySubDimension = (
      <div className="comparativeAnalysisComponent-preview">
        <div className="comparativeAnalysisComponent-preview-header">
        Este <strong>grupo</strong> aún no cumple el <strong>anonimato</strong> dentro del segmento para mostrar el resultado.
        </div>
      </div>
    )

    const contentNotAnonymityDimension = (
      <div className="comparativeAnalysisComponent-preview">
        <div className="comparativeAnalysisComponent-preview-header">
        Este <strong>grupo</strong> aún no cumple el <strong>anonimato</strong> para mostrar el resultado.
        </div>
      </div>
    )

    return columns.map((c, i) => {
      const view = (
        <Fragment key={i}>
          {c.skeleton ? (
            <td className={i === 0 ? " columnCollaborator-value" : ""}>
              {" "}
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: "100%" }}
              />
            </td>
          ) : name !== null && c.id_dimension !== null ? (
            <Popover
              align={{ targetOffset: [-15, 0] }}
              overlayClassName={
                c.value_visible === "N/A"
                  ? ""
                  : "comparativeAnalysisComponent-preview"
              }
              placement="leftBottom"
              content={
                c.value_visible === "N/A"
                  ? "No se cuenta con información para este segmento."
                  : c.id_measure_metric == 0 && c.id_dimension_parent == null
                    ? contentNotDimension
                    : c.id_measure_metric == 0 && c.id_dimension_parent > 0
                      ? contentNotSubDimension
                      : c.check_anonymity == false && c.id_dimension_parent > 0
                        ? contentNotAnonymitySubDimension
                        : c.check_anonymity == false && c.id_dimension_parent == null
                          ? contentNotAnonymityDimension
                          : content
              }
              arrowPointAtCenter
              trigger={c.value_visible === "N/A" ? "hover" : "click"}
              onVisibleChange={(e) => {
                if (e === true && c.value_visible !== "N/A" && c.id_measure_metric != 0 && c.check_anonymity == true) {
                  // if(c.id_measure_metric != 0 && c.check_anonymity == true){
                    this.props.clickIndicator(c)
                  // }
                } else if (document.querySelector(".ant-popover-open"))
                  document.querySelector(".ant-popover-open").click()
              }}>
              <td style={{ backgroundColor: c.color }}>{c.value_visible}</td>
            </Popover>
          ) : (
            <td style={{ backgroundColor: c.color, cursor: "default" }}>
              {c.value_visible}
            </td>
          )}
          {openDimensions.includes(c.id_dimension) &&
            this.renderDivisionColumn(c.childs, name)}
        </Fragment>
      )
      if (this.props.isEngagement) return view

      if (!c.engagement) {
        return view
      }
    })
  }

  renderDivisionItem = (d) => {
    const { openDivisions } = this.props
    let level = d.level
    level = level === null ? 0 : level - 1
    if (isNaN(level)) {
      level = 0
    }
    const idToUse = d.id_position ? d.id_position : d.id_division
    return (
      <Fragment>
        <th style={{ backgroundColor: level > 0 ? "#F3F3F3" : "" }}>
          {d.skeleton ? (
            <div style={{ paddingLeft: level * 10 }}>
              <Skeleton
                active
                title={false}
                paragraph={{
                  rows: 1,
                  width: `calc(100% - ${level * 10}px)`,
                }}
              />
            </div>
          ) : (
            <Tooltip
              title={
                d.segment_name
                  ? d.segment_name
                  : d.name
                  ? d.name
                  : this.intlComparativeAnalysisTable.organization
              }>
              <span
                style={{
                  paddingLeft: level * 10,
                  fontWeight: level > 0 ? "400" : "500",
                }}>
                {d.segment_name
                  ? d.segment_name
                  : d.name
                  ? d.name
                  : this.intlComparativeAnalysisTable.organization}
              </span>
            </Tooltip>
          )}
          {d.division_childs && d.division_childs > 0 ? (
            openDivisions.includes(idToUse) ? (
              <img
                src={FlechaSVG}
                style={{ transform: "rotate(-90deg)" }}
                onClick={() =>
                  d.division_childs > 0 ? this.props.clickDivision(d) : null
                }
              />
            ) : (
              <img
                src={FlechaSVG}
                style={{ transform: "rotate(-180deg)" }}
                onClick={() =>
                  d.division_childs > 0 ? this.props.clickDivision(d) : null
                }
              />
            )
          ) : null}
        </th>
        {!d.skeleton && d.employees != "-" && (
          <td className="columnCollaborator columnCollaborator-value">
            {d.employees || 0}
          </td>
        )}
        {this.renderDivisionColumn(d.dimensions, d.name)}
      </Fragment>
    )
  }

  renderDivisionList = (divisions) =>
    divisions.map((d, i) => {
      const idToUse = d.id_position ? d.id_position : d.id_division
      return (
        <Fragment key={i}>
          <tr
            id={d.skeleton ? "isSkeleton" : `area_${idToUse}`}
            className={this.props.indicatorLoading ? "blocked_actions" : ""}>
            {this.renderDivisionItem(d)}
          </tr>
          {d.childs && this.renderDivisionList(d.childs)}
        </Fragment>
      )
    })

  renderLoaderInfiniteScroll = () => {
    return (
        <Spin style={{display:"flex", justifyContent: "center", padding: "2.5rem 0px"}} size="large" />
    )
  }

  render() {
    const { headers, body, loading, currentPage, lastPage } = this.props
    return (
      <div className="comparativeAnalysisComponent" >
        {loading && (
          <div className="loadingCss">
            <div style={{ position: "relative", top: "50%" }}>
              <Spin size="large" />
            </div>
          </div>
        )}
        <div
          className="comparativeAnalysisComponent-table"
          id="comparativeAnalysisTable">
            <InfiniteScroll
              loader={this.renderLoaderInfiniteScroll()}
              pageStart={0}
              hasMore={currentPage < lastPage && lastPage != 1}
              loadMore={() => {
                // idk why but hasMore is not working after you choose another segment in selector and calls twice api, so I added the same condition
                if(currentPage < lastPage && lastPage != 1){
                  this.props.getDivisionsScroller(this.props.currentPage + 1)
                }
              }}
              style={{ overflow: "auto", minWidth: "100%" }}
            >
              <table>
                <thead>
                  <tr>
                    <th />
                    {headers.length > 0 &&
                      body.length > 0 &&
                      body[0].employees != "-" && (
                        <th className="verticalText columnCollaborator">
                          <div>
                            <span>
                              {this.intlComparativeAnalysisTable.collaborators}
                              <Popover
                                placement="top"
                                content={
                                  <div
                                    style={{ maxWidth: 220, textAlign: "center" }}>
                                    {sanitize(
                                      this.intlComparativeAnalysisTable.popover
                                    )}
                                  </div>
                                }>
                                <QuestionCircleFilled
                                  style={{
                                    color: "#D8D8D8",
                                    verticalAlign: "baseline",
                                    fontSize: "14px",
                                    marginLeft: 8,
                                  }}
                                />
                              </Popover>
                            </span>
                          </div>
                        </th>
                      )}
                    {this.renderHeaderList(headers)}
                  </tr>
                </thead>
                <tbody>{this.renderDivisionList(body)}</tbody>
              </table>
            </InfiniteScroll>

        </div>
      </div>
    )
  }
}

ComparativeAnalysisTable.propTypes = {
  loading: PropTypes.bool,
  openDimensions: PropTypes.array,
  openDivisions: PropTypes.array,
  clickDimension: PropTypes.func,
  clickDivision: PropTypes.func,
  clickBoxValue: PropTypes.func,
}

export default ComparativeAnalysisTable
